import { Link } from 'react-router-dom';

import { Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

type Props = {
  linkProps?: {
    to: string;
    target?: string;
  };
  tier: 'PLUS' | 'ENTERPRISE';
  tooltipMsg?: string;
  className?: string;
  onClick?: () => void;
};

const UpsellBadge = (props: Props) => {
  return (
    <Tooltip title={props.tooltipMsg}>
      {props.linkProps ? (
        <Link
          {...props.linkProps}
          className={cn(
            'inline-flex cursor-pointer items-center rounded-2xl border border-brand px-1.5 py-1 ' +
              'text-[11px] font-semibold leading-[11px] text-brand-primary',
            props.className
          )}
          onClick={props.onClick}
        >
          {props.tier}
        </Link>
      ) : (
        <button
          onClick={props.onClick}
          type="button"
          className={cn(
            'inline-flex cursor-pointer items-center rounded-2xl border border-brand px-1.5 py-1 ' +
              'text-[11px] font-semibold leading-[11px] text-brand-primary',
            props.className
          )}
        >
          {props.tier}
        </button>
      )}
    </Tooltip>
  );
};

export { UpsellBadge };
